import React, { PropsWithChildren } from 'react';
import { CssBaseline, ThemeProvider as MaterialProvider } from '@material-ui/core';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { ptBR } from "date-fns/locale";
import { SnackbarProvider } from 'notistack';
import { DarkTheme, DefaultTheme } from '../themes';
import DateFnsUtils from '@date-io/date-fns';

export interface IThemeContext {
    isDarkMode: boolean;
    toggleTheme(): void;
}

export const ThemeContext = React.createContext({} as IThemeContext);

export const ThemeProvider: React.FC<PropsWithChildren> = ({ children }) => {

    const { Provider } = ThemeContext;

    const [isDarkMode, setIsDarkMode] = React.useState(false);

    React.useEffect(() => {
        loadData();
    }, []);

    function loadData() {
        const theme = window.localStorage.getItem('@pricememo:theme');
        if (theme) setIsDarkMode(Boolean(JSON.parse(theme)));
    }

    function toggleTheme() {
        setIsDarkMode(!isDarkMode);
        window.localStorage.setItem('@pricememo:theme', JSON.stringify(!isDarkMode));
    }

    let theme = isDarkMode ? DarkTheme : DefaultTheme;

    return (
        <Provider value={{ toggleTheme, isDarkMode }}>
            <MaterialProvider theme={theme}>
                <SnackbarProvider variant="error">
                    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
                        <CssBaseline />
                        {children}
                    </MuiPickersUtilsProvider>
                </SnackbarProvider>
            </MaterialProvider>
        </Provider>
    );
}

export const useTheme = (): IThemeContext => { return React.useContext(ThemeContext); }